import "./calculator.css";
import { Stepper } from "../Stepper/Stepper";
import calculatorData from "../../data/calculator.json";
import { CalculatorQuestions } from "../CalculatorQuestions/CalculatorQuestions";
import React from "react";
import { useGoogleTagManager } from "@tracktor/react-google-tag-manager";

interface CalculatorProps {
  onBack: () => void;
  answers: Record<string, number>;
  onAnswerChange: (questionKey: string, value: number) => void;
  onEnd: () => void;
}

const domains = calculatorData.domains;

export const Calculator = ({
  onBack,
  answers,
  onAnswerChange,
  onEnd,
}: CalculatorProps) => {
  const [currentDomainIndex, setCurrentDomainIndex] = React.useState(0);
  const { sendEvent } = useGoogleTagManager();

  const handleAnswerChange = (questionKey: string, value: string) => {
    sendEvent({
      event: "gtm.change_form",
      formId: "biogen_mfars_calculator",
      elementID: `step_${questionKey}`,
      value: value,
      nodeName: "SELECT",
      type: "radio",
    });
    const numericValue = value === "presente" ? 1 : 0;
    onAnswerChange(questionKey, numericValue);
  };

  const handleNext = () => {
    if (currentDomainIndex === domains.length - 1) {
      onEnd();
      return;
    }
    setCurrentDomainIndex(currentDomainIndex + 1);
  };

  const areAllQuestionsAnswered = () => {
    const currentQuestions = currentDomain.questions;
    return currentQuestions.every(
      (question) => answers[question.key] !== undefined
    );
  };

  const handlePrev = () => {
    if (currentDomainIndex === 0) return onBack();
    setCurrentDomainIndex(currentDomainIndex - 1);
  };

  const currentDomain = domains[currentDomainIndex];

  return (
    <form
      id="biogen_mfars_calculator"
      className="calculator-container"
    >
      <div className="calculator-content">
        <Stepper
          totalSteps={domains.length}
          currentStep={currentDomainIndex + 1}
          variant="primary"
        />
        <div className="calculator-domain">
          <h1 className="domain-title">
            Domínio {currentDomainIndex + 1} - {currentDomain.name}
          </h1>
          <h4 className="domain-description">{currentDomain.description}</h4>

          <CalculatorQuestions
            questions={currentDomain.questions}
            onAnswerChange={handleAnswerChange}
            answers={answers}
          />
        </div>
      </div>
      <div className="calculator-actions">
        <button
          className="prev-button"
          type="button"
          data-name="biogen_Back"
          onClick={handlePrev}
        >
          Anterior
        </button>
        <button
          className="next-button"
          data-name="biogen_Next"
          onClick={() =>handleNext()}
          disabled={!areAllQuestionsAnswered()}
        >
          Próximo
        </button>
      </div>
    </form>
  );
};
